<section class="account-balance-page">
  <section class="account-balance-layout-card">
    <header class="account-balance-hero">
      <div>
        <h1 class="sam-page-heading">LÖNESALDO</h1>
        <p>Se kommande nettolön och en sammanställning av dina utbetalningar.</p>
      </div>
    </header>

    <div *ngIf="isLoading" class="balance-skeleton" aria-hidden="true">
      <div class="balance-skeleton-section" *ngFor="let _ of [1,2,3]">
        <span class="balance-skeleton-title"></span>
        <div class="balance-skeleton-row" *ngFor="let _ of [1,2,3]">
          <span></span><span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <div class="balance-content" [class.balance-content-loading]="isLoading">
      <section class="balance-list-section" aria-labelledby="outstanding-salary-title">
        <header class="balance-section-header">
          <div>
            <span class="section-eyebrow">Kommande</span>
            <h2 id="outstanding-salary-title">Innestående nettolön</h2>
          </div>
          <strong class="balance-total">{{ totalNetSalaryToRecieve | number:'1.0-0' }} kr</strong>
        </header>

        <div class="balance-table-shell">
          <mat-table [dataSource]="dataSource" class="balance-table">
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row?.Type?.Name}}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Totalt</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef>Belopp (netto)</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row?.NetSalary | number:'1.0-0'}} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalNetSalaryToRecieve | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="due">
              <mat-header-cell *matHeaderCellDef>Förfallodatum / Villkor</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row?.PayoutDate | swedishDate:'yyyy-MM-dd' }}</mat-cell>
              <mat-footer-cell *matFooterCellDef></mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
          </mat-table>
        </div>
      </section>

      <section class="balance-list-section" aria-labelledby="current-year-title">
        <header class="balance-section-header">
          <div>
            <span class="section-eyebrow">{{currentYear}}</span>
            <h2 id="current-year-title">Sammanställning per månad</h2>
          </div>
          <span class="section-hint">Klicka på en månad för att visa transaktioner</span>
        </header>

        <div class="balance-table-shell">
          <mat-table [dataSource]="dataSource2" multiTemplateDataRows class="balance-table">
            <ng-container matColumnDef="Month">
              <mat-header-cell *matHeaderCellDef>Månad</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ getSwedishMonthName(row.Month) }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Totalt</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="NetSalarySum">
              <mat-header-cell *matHeaderCellDef>Utbetalad nettolön</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.NetSalarySum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalNetSalary | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="PensionSum">
              <mat-header-cell *matHeaderCellDef>Inbetald pension</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.PensionSum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalPension | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="AttachmentSum">
              <mat-header-cell *matHeaderCellDef>Utmätt belopp</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row.AttachmentSum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalAttachment | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns2.length">
                <div *ngIf="expandedElement === row" class="detail-container">
                  <div class="detail-table-shell">
                    <table class="transactions-table">
                      <thead>
                        <tr>
                          <th>Typ</th>
                          <th>Datum</th>
                          <th>Nettolön</th>
                          <th>Pension</th>
                          <th>Utmätning</th>
                          <th>Faktura</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let t of row.Transactions">
                          <td>{{ t.Type?.Name }}</td>
                          <td>{{ t.PayoutDate | swedishDate: 'yyyy-MM-dd' }}</td>
                          <td>{{ t.NetSalary | number:'1.0-0' }} kr</td>
                          <td>{{ t.PensionSavings | number:'1.0-0' }} kr</td>
                          <td>{{ t.AttachmentOfSalaryAmount | number:'1.0-0' }} kr</td>
                          <td>
                            <a [href]="t.InvoiceDocumentUrl" target="_blank" rel="noopener" aria-label="Öppna faktura">
                              <mat-icon>picture_as_pdf</mat-icon>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns2"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns2"
                     class="main-row"
                     (click)="expandedElement = expandedElement === row ? null : row">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                     class="detail-row"
                     [style.display]="expandedElement === row ? '' : 'none'">
            </mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns2"></mat-footer-row>
          </mat-table>
        </div>
      </section>

      <section class="balance-list-section" aria-labelledby="previous-years-title">
        <header class="balance-section-header">
          <div>
            <span class="section-eyebrow">Historik</span>
            <h2 id="previous-years-title">Sammanställning per år</h2>
          </div>
        </header>

        <div class="balance-table-shell">
          <mat-table [dataSource]="dataSource3" class="balance-table">
            <ng-container matColumnDef="Year">
              <mat-header-cell *matHeaderCellDef>År</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row?.Year }}</mat-cell>
              <mat-footer-cell *matFooterCellDef>Totalt</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="NetSalarySum">
              <mat-header-cell *matHeaderCellDef>Utbetalad nettolön</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row?.NetSalarySum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalNetSalary3 | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="PensionSum">
              <mat-header-cell *matHeaderCellDef>Inbetald pension</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row?.PensionSum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalPension3 | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <ng-container matColumnDef="AttachmentSum">
              <mat-header-cell *matHeaderCellDef>Utmätt belopp</mat-header-cell>
              <mat-cell *matCellDef="let row">{{ row?.AttachmentSum | number:'1.0-0' }} kr</mat-cell>
              <mat-footer-cell *matFooterCellDef>{{ totalAttachment3 | number:'1.0-0' }} kr</mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns3"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns3;"></mat-row>
            <mat-footer-row *matFooterRowDef="displayedColumns3"></mat-footer-row>
          </mat-table>
        </div>
      </section>
    </div>
  </section>
</section>
